import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useEffect } from 'react';
import {
	NotificationsOrder,
	isResponseStatus,
	notificationsQuery,
	usePoQuery,
	useAxiosInstance,
} from '@gov-nx/api';
import { useConnection } from '@gov-nx/core/hooks';
import { isUnreadNotification } from '@gov-nx/module/page';

interface NotificationMessageLoaderProps {
	enabled: boolean;
}

export const useNotificationMessageLoader = (
	config: NotificationMessageLoaderProps = { enabled: true }
) => {
	const { isOnline } = useConnection();
	const queryClient = useQueryClient();
	const { axiosInstance } = useAxiosInstance();

	const allNotificationsQuery = usePoQuery(
		{
			queryKey: ['notifications'],
			queryFn: () =>
				notificationsQuery(axiosInstance, {
					razeni: NotificationsOrder['-datumACasVytvoreni'],
					start: 0,
					pocet: 50,
				}),
			retry: 1,
			enabled: isOnline && config.enabled,
		},
		{
			errorIgnoreFilter: isResponseStatus(500),
		}
	);

	const reloadNotifications = useCallback(async () => {
		await queryClient.invalidateQueries({ queryKey: ['notifications'] });
	}, [queryClient]);

	const unreadNotifications =
		allNotificationsQuery.data?.seznam?.filter(isUnreadNotification) ?? [];

	useEffect(() => {
		reloadNotifications();
	}, [isOnline, reloadNotifications]);

	return {
		unreadNotificationsCount: unreadNotifications.length,
		unreadNotifications,
		reloadNotifications,
	};
};
